export const selectTenantNetwork = (state) => state.networks.tenantNetwork;
export const selectTenantNetworkLoading = (state) => state.networks.tenantNetworkLoading;
export const selectTenantNetworks = (state) => state.networks.tenantNetworks;
export const selectMetaDataList = (state) => state.networks.metaDataList;
export const selectCheckerScreen = (state) => state.networks.checkerScreen;
